import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import promoboxes from '../styles/img/promo_boxes.png';
import { useSelector } from 'react-redux';
import succesanimation from '../styles/lottie/succesanimation.json';
import pikkocoin from '../styles/img/Pikkocoin.svg';
import BackButton from '../components/button/BackButton';
import {
  ACCOUNT,
  CART,
  INVITATION,
  NUMBER_SCREEN,
  PROMO,
  SCAN,
  STORE_LIST,
} from '../constants/routes';
import Lottie from 'lottie-react';
import { useFunnelTracking } from '../posthog/funnelTracking';

const Invitation = ({ invitationVisible }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const { trackPageViewInvitation } = useFunnelTracking();
  
  useEffect(() => {
    trackPageViewInvitation({});
  }, [trackPageViewInvitation]);

  const goNext = (nextStep) => {
    localStorage.setItem('PREV_LOGIN_PAGE', INVITATION);
    navigate(`${nextStep}`, { state: { prevPage: INVITATION } });
  };

  const redirectToScan = () => {
    if (store) {
      goNext(SCAN);
    } else {
      navigate(STORE_LIST, { state: { prevPage: SCAN } });
    }
  };

  useEffect(() => {
    if (user && user._id) {
      navigate(PROMO);
    }
  }, []);

  return (
    <div className="h-full overflow-scroll relative z-[100] bg-gradient1">
      <div className="back-header">
        <BackButton onClick={redirectToScan} />
      </div>
      <div className="container_invitation_page">
        <div className="logo_invitation">
          <Lottie
            animationData={succesanimation}
            loop={false}
            // onAnimationComplete={handleFirstAnimation}
            className={'invitation_logo'}
          />
        </div>

        <div className="invitation_text_and_coin">
          <div className="invitation_title">Pikko Compte</div>
        </div>
        <div className="invitation_text_secondary">
          Crée ton compte PikkoPay et accède à de nombreux avantages !
        </div>
        <div className="invitation_btn_next_connect">
          <button
            onClick={() => goNext(NUMBER_SCREEN)}
            className="btn_connect payer"
          >
            Me connecter / M'inscrire
          </button>
          <button onClick={() => goNext(CART)} className="btn_next">
            Passer cette étape
            <span className="text-6xl pt-[1px]" style={{ fontSize: '2rem' }}>
              &#10140;
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Invitation;
